import React from 'react';

function inline(text) {
  return text.split(/(\*\*.+?\*\*|`.+?`)/g).map((part, i) =>
    part.startsWith('**') ? <strong key={i}>{part.slice(2, -2)}</strong> :
      part.startsWith('`') ? <code key={i}>{part.slice(1, -1)}</code> : part);
}

const cells = line => line.trim().replace(/^\|/, '').replace(/\|$/, '')
  .split(/(?<!\\)\|/).map(cell => cell.trim().replace(/\\\|/g, '|'));
const isRow = line => line && line.trim().includes('|');

export default function ReportMarkdown({ text }) {
  if (!text) return null;
  const lines = text.replace(/\r/g, '').split('\n');
  const out = [];
  let list = [];
  const flush = () => {
    if (list.length) out.push(<ul key={`list-${out.length}`}>{list.map((item, i) => <li key={i}>{inline(item)}</li>)}</ul>);
    list = [];
  };
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    let next = i + 1;
    while (next < lines.length && !lines[next].trim()) next++;
    const header = cells(line);
    const divider = next < lines.length ? cells(lines[next]) : [];
    let bodyStart = next + 1;
    while (bodyStart < lines.length && !lines[bodyStart].trim()) bodyStart++;
    const standardDivider = divider.every(cell => /^:?-{3,}:?$/.test(cell));
    // Some saved AI reports lose divider dashes. Recover only a bordered,
    // empty divider followed by a row with the same column count.
    const emptyDivider = /^\|[\s|]+\|$/.test((lines[next] || '').trim()) &&
      divider.every(cell => cell === '') && isRow(lines[bodyStart]) &&
      cells(lines[bodyStart]).length === header.length;
    if (header.length >= 2 && isRow(line) && divider.length === header.length && (standardDivider || emptyDivider)) {
      flush();
      const rows = [];
      i = next;
      while (i + 1 < lines.length) {
        let rowIndex = i + 1;
        while (rowIndex < lines.length && !lines[rowIndex].trim()) rowIndex++;
        if (!isRow(lines[rowIndex])) break;
        const row = cells(lines[rowIndex]);
        if (row.length !== header.length) break;
        rows.push(row);
        i = rowIndex;
      }
      const align = column => divider[column].endsWith(':') ? (divider[column].startsWith(':') ? 'center' : 'right') : 'left';
      out.push(<div className="report-table-scroll" key={`table-${i}`} tabIndex={0} role="region" aria-label="Report table">
        <table><thead><tr>{header.map((cell, column) => <th scope="col" key={column} style={{ textAlign: align(column) }}>{inline(cell)}</th>)}</tr></thead>
          <tbody>{rows.map((row, index) => <tr key={index}>{row.map((cell, column) => <td key={column} style={{ textAlign: align(column) }}>{inline(cell)}</td>)}</tr>)}</tbody></table>
      </div>);
      continue;
    }
    const heading = line.match(/^(#{1,4})\s+(.+)$/);
    if (heading) { flush(); out.push(React.createElement(`h${heading[1].length}`, { key: i }, inline(heading[2]))); }
    else if (/^[-*+•]\s+/.test(line)) list.push(line.replace(/^[-*+•]\s+/, ''));
    else { flush(); if (line) out.push(<p key={i}>{inline(line)}</p>); }
  }
  flush();
  return <>{out}</>;
}
